import { render, staticRenderFns } from "./mailLinkmanEdit.vue?vue&type=template&id=5a6793be&scoped=true&"
import script from "./mailLinkmanEdit.vue?vue&type=script&lang=js&"
export * from "./mailLinkmanEdit.vue?vue&type=script&lang=js&"
import style0 from "./mailLinkmanEdit.vue?vue&type=style&index=0&id=5a6793be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6793be",
  null
  
)

export default component.exports